'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _formatAddress = require('../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _ShareBlock = require('../ShareBlock/ShareBlock');var _ShareBlock2 = _interopRequireDefault(_ShareBlock);
var _makeSharingUrl = require('../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _checkIsForeignAddress = require('../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _chats = require('../../../static/icons/chats.svg');var _chats2 = _interopRequireDefault(_chats);

var _MyProjectCard = require('./MyProjectCard.scss');var styles = _interopRequireWildcard(_MyProjectCard);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var currencies = {
  ILS: '₪',
  USD: '$',
  EUR: '€' };var


MyProjectCard = function (_Component) {_inherits(MyProjectCard, _Component);function MyProjectCard() {var _temp, _this, _ret;_classCallCheck(this, MyProjectCard);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      isDeactivatedProject: _this.props.project.is_deactivated,
      isShare: false }, _this.











    handleEdit = function (event) {
      event.stopPropagation();var _this$props$project =
      _this.props.project,id = _this$props$project.id,address = _this$props$project.address;
      var isForeign = (0, _checkIsForeignAddress2.default)(address);

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(
      _this.props.locale, (
      isForeign ? '/foreign_project' : '/project') + '/edit?id=' + id));

    }, _this.

    handlePushLeads = function (event) {
      event.stopPropagation();var
      id = _this.props.project.id;

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/profile/leads?project_id=' + id));
    }, _this.

    handleAddComment = function (event) {
      event.stopPropagation();var
      id = _this.props.project.id;

      _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/project_details/' + id));
    }, _this.

    handleClickDeactivate = function () {var _this$props =
      _this.props,userToken = _this$props.userToken,project = _this$props.project;

      _this.props.hideMessageModal();
      _this.props.deactivateProject({
        isDeactivated: _this.state.isDeactivatedProject,
        token: userToken,
        id: project.id });

    }, _this.

    openDiactivateProjectModal = function (event) {
      event.stopPropagation();

      return _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('div', null,
            !_this.state.isDeactivatedProject ?
            _react2.default.createElement('p', null, _this.props.translate('myProjects', 'deactivateProject')) :
            _react2.default.createElement('p', null, _this.props.translate('myProjects', 'activateProject')),

            _react2.default.createElement('div', { className: styles.modalButtonWrapper },
              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.handleClickDeactivate },

                _this.props.translate('myProjects', 'yes')),

              _react2.default.createElement('button', {
                  className: 'btn btn-primary',
                  onClick: _this.props.hideMessageModal },

                _this.props.translate('myProjects', 'no'))))) });







    }, _this.

    handleShare = function (event) {
      event.stopPropagation();
      _this.setState(function (prevState) {return { isShare: !prevState.isShare };});
    }, _this.
    formatShareData = function () {var _this$props2 =
      _this.props,project = _this$props2.project,locale = _this$props2.locale;

      var formattedAddress = (0, _formatAddress2.default)(project.address[_this.props.locale] || project.address.en);
      var propertyId = project.id;
      var sharingUrl = (0, _makeSharingUrl2.default)('/?id=project_' + project.id, locale);
      var sharingTitle = _this.props.translate('myProjects', 'projectIn') + ' ' + formattedAddress;
      var thumbnail = project.images.length ? project.images[0] : project.logo;

      return {
        propertyId: propertyId,
        sharingTitle: sharingTitle,
        sharingUrl: sharingUrl,
        thumbnail: thumbnail };

    }, _this.

    share = function () {return (
        _react2.default.createElement(_ShareBlock2.default, {
          isCloseЕitle: true,
          locale: _this.props.locale,
          translate: _this.props.translate,
          sharingData: _this.formatShareData(),
          copyLinkTitle: '' + _this.props.translate('copyLink'),
          emailTitle: '' + _this.props.translate('propertyDetails', 'contacts', 'email'),
          className: 'shareProjectCard',
          sizeIcon: 32,
          iconFill: true }));}, _this.



    renderCards = function () {var _cx, _cx2;var _this$props3 =















      _this.props,translate = _this$props3.translate,locale = _this$props3.locale,_this$props3$project = _this$props3.project,images = _this$props3$project.images,logo = _this$props3$project.logo,exact_property_price = _this$props3$project.exact_property_price,min_property_price = _this$props3$project.min_property_price,address = _this$props3$project.address,property_types = _this$props3$project.property_types,leads = _this$props3$project.leads,created_at = _this$props3$project.created_at,name = _this$props3$project.name,currency = _this$props3$project.currency;var
      isDeactivatedProject = _this.state.isDeactivatedProject;
      var imagesLabel = images.length ? images[0] : logo;
      var price = (0, _beautifyNumber2.default)(exact_property_price || min_property_price);
      var formattedAddress = (0, _formatAddress2.default)(address[locale] || address.en);
      var publishDate = (0, _moment2.default)(created_at).format('DD/MM/YYYY');
      var projectName = name[locale] || name.en || name.he;
      var deactivated = isDeactivatedProject ?
      translate('myProjects', 'Activate') :
      translate('myProjects', 'Deactivate');
      var propertyTypes = property_types.length < 2 ?
      translate('propertyTypes', property_types[0]) :
      translate('propertyTypes', property_types[0]) + '...';

      return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(
            styles.cards, (_cx = {}, _cx[
            styles.inactive] = isDeactivatedProject, _cx)) },


          _react2.default.createElement('div', { className: styles.images },
            _react2.default.createElement('div', { className: styles.inactiveImages }),
            _react2.default.createElement('img', { src: imagesLabel, alt: '' }),
            _this.state.isShare && _this.share(),
            _react2.default.createElement('div', { className: styles.share, onClick: _this.handleShare },
              _react2.default.createElement('i', { className: 'icon icon-share-project' })),

            _react2.default.createElement('div', { className: styles.price },
              _react2.default.createElement('span', null,
                currencies[currency] || currencies.ILS, ' ', price))),



          _react2.default.createElement('div', { className: styles.publishDate },
            _react2.default.createElement('span', null, publishDate)),

          _react2.default.createElement('div', { className: styles.infoWrapper },
            _react2.default.createElement('div', { className: styles.info },
              _react2.default.createElement('div', { className: styles.propertyTypes },
                projectName),

              _react2.default.createElement('div', { className: styles.address },
                formattedAddress)),


            _react2.default.createElement('div', { className: styles.edit, onClick: _this.handleEdit },
              _react2.default.createElement('i', { className: 'icon icon-edit-project' }),
              translate('myProjects', 'edit'))),


          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.leadsWrapper, styles.chatsWrapper), onClick: _this.handleAddComment },
            _react2.default.createElement('div', { className: styles.chatsText },
              _react2.default.createElement('img', { src: _chats2.default, className: styles.icon, alt: '' }),
              _react2.default.createElement('span', null, translate('propertyDetails', 'messageCard'))),

            _react2.default.createElement('div', { className: styles.goLeads },
              _react2.default.createElement('i', { className: 'icon icon-back' }))),


          _react2.default.createElement('div', { className: styles.leadsWrapper, onClick: _this.handlePushLeads },
            _react2.default.createElement('div', { className: styles.leads },
              _react2.default.createElement('i', { className: 'icon icon-eye-project' }),
              leads, ' ', translate('myProjects', 'leads')),

            _react2.default.createElement('div', { className: styles.goLeads },
              _react2.default.createElement('i', { className: 'icon icon-back' }))),


          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(styles.deactivatedWrapper, (_cx2 = {}, _cx2[styles.deactivated] = isDeactivatedProject, _cx2)),
              onClick: _this.openDiactivateProjectModal },

            deactivated)));



    }, _temp), _possibleConstructorReturn(_this, _ret);}MyProjectCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var _this2 = this;var myProjects = _ref.myProjects;if (myProjects.diaсtivatedProject !== this.props.myProjects.diaсtivatedProject) {this.setState(function (prevState) {return myProjects.diaсtivatedProject.id === _this2.props.project.id && { isDeactivatedProject: !prevState.isDeactivatedProject };});}};MyProjectCard.prototype.

  render = function render() {
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.wrapper) },
        this.renderCards()));


  };return MyProjectCard;}(_react.Component);


MyProjectCard.propTypes = {
  locale: _propTypes2.default.string,
  userToken: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  project: _propTypes2.default.object,
  myProjects: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  deactivateProject: _propTypes2.default.func };exports.default =


MyProjectCard;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyProjectCard/MyProjectsCard.js
// module id = 2710
// module chunks = 0